import * as images from "@/components/images/Images";
import type { IndustriesHeroData } from "./types";
import { ROUTES } from "@/constants";

export const industriesHeroData = {
  title: "Professional translation services for any industry",
  description:
    "Extend your global audience using affordable, high-quality human translators specialized in your industry across 100+ languages.",
  primaryButton: {
    href: ROUTES.startOrder,
    label: "Start order",
  },
  secondaryButton: {
    href: ROUTES.getQuote,
    label: "Get a quote",
  },
  imageUrl: images.industriesHeroImg,
  imageDimensions: {
    width: 2408,
    height: 2108,
  },
} as IndustriesHeroData;
